import { Actor } from "./actor";
const WALK_VELOCITY = 110;
const BODY_SIZE = { width: 14, height: 16 };
const BODY_OFFSET = { x: 0, y: 5 };

export class Player extends Actor {
  private keys: { [key: string]: Phaser.Input.Keyboard.Key } = {};

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, "User");
    this.setName("User");
    this.initKeyboard();
    this.initPhysics();
    this.initAnimations();
  }

  update(): void {
    this.handleMovement();
    this.updateDepth();
  }

  private initKeyboard(): void {
    const keyNames = ["W", "A", "S", "D", "UP", "LEFT", "DOWN", "RIGHT"];
    for (let key of keyNames) {
      this.keys[key] = this.scene.input.keyboard.addKey(key);
    }
  }

  private initPhysics(): void {
    this.getBody().setSize(BODY_SIZE.width, BODY_SIZE.height);
    this.getBody().setOffset(BODY_OFFSET.x, BODY_OFFSET.y);
  }

  private handleMovement(): void {
    this.getBody().setVelocity(0);
    let pressedFlag = false;

    if (
      (this.keys.W.enabled && this.keys.W.isDown) ||
      (this.keys.UP.enabled && this.keys.UP.isDown)
    ) {
      this.move("up");
      pressedFlag = true;
    }

    if (
      (this.keys.A.enabled && this.keys.A.isDown) ||
      (this.keys.LEFT.enabled && this.keys.LEFT.isDown)
    ) {
      this.move("left");
      pressedFlag = true;
    }

    if (
      (this.keys.S.enabled && this.keys.S.isDown) ||
      (this.keys.DOWN.enabled && this.keys.DOWN.isDown)
    ) {
      this.move("down");
      pressedFlag = true;
    }

    if (
      (this.keys.D.enabled && this.keys.D.isDown) ||
      (this.keys.RIGHT.enabled && this.keys.RIGHT.isDown)
    ) {
      this.move("right");
      pressedFlag = true;
    }

    if (!pressedFlag && this.anims.isPlaying) {
      this.anims.setCurrentFrame(this.anims.currentAnim.frames[0]);
    }
  }

  private move(direction: "up" | "down" | "left" | "right"): void {
    switch (direction) {
      case "up":
        this.getBody().setVelocityY(-WALK_VELOCITY);
        this.anims.play(this.name + "-walk-up", true);
        break;
      case "left":
        this.getBody().setVelocityX(-WALK_VELOCITY);
        this.anims.play(this.name + "-walk-left", true);
        break;
      case "down":
        this.getBody().setVelocityY(WALK_VELOCITY);
        this.anims.play(this.name + "-walk-down", true);
        break;
      case "right":
        this.getBody().setVelocityX(WALK_VELOCITY);
        this.anims.play(this.name + "-walk-right", true);
        break;
    }
  }

  private updateDepth(): void {
    this.depth = this.y + 0.5 * this.height;
  }
}
